export { default as SwupPagePreloadPlugin } from './preloader.ts'
export type {
  PagePreloader,
  PagePreloaderOptions,
  PreloadOptions,
  PreloadStrategy,
} from './types.ts'
